import { render, staticRenderFns } from "./DialogMudarParaPendente.vue?vue&type=template&id=0e7ab154&scoped=true&"
import script from "./DialogMudarParaPendente.vue?vue&type=script&lang=js&"
export * from "./DialogMudarParaPendente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ab154",
  null
  
)

export default component.exports